import React, { useState } from "react";
import "../styles/common/Modal.css";
import Modal from "./common/Modal";
import MusicalNoteIcon from './icons/musical-note'
import { getStoredUserProfile } from '../utils/authStorage';
import { buildApiUrl } from '../lib/api';

const DeleteScoreModal = ({ onClose, scoreId, title, artist, onDeleted, onNotify, userId: userIdProp }) => {
  const [submitting, setSubmitting] = useState(false);

  const handleDelete = async () => {
    if (submitting) return;
    let userId = userIdProp;
    if (!userId) {
      const userProfile = getStoredUserProfile();
      userId = userProfile?.uid || userProfile?.sub || null;
    }
    if (!userId || !scoreId) {
      console.error("Missing userId or scoreId");
      onNotify?.({ title: 'Error', message: 'Unable to delete score. Missing information.', variant: 'error' });
      return;
    }

    try {
      setSubmitting(true);
      const res = await fetch(buildApiUrl('/delete-score'), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userId,
          scoreId,
        }),
      });

      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        console.error("Error deleting score:", data);
        onNotify?.({ title: 'Error', message: 'Failed to delete score.', variant: 'error' });
        return;
      }

      if (onDeleted) {
        onDeleted(scoreId);
      } else {
        window.location.reload();
      }
      onNotify?.({ title: 'Deleted', message: 'Score deleted successfully.', variant: 'success' });
    } catch (error) {
      console.error("Error deleting score:", error);
      onNotify?.({ title: 'Error', message: 'Failed to delete score.', variant: 'error' });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      isOpen
      onClose={onClose}
      contentClassName="delete-score-modal modal-content--modern"
      contentProps={{
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "confirm-title",
        tabIndex: -1,
        onKeyDown: (e) => {
          if (e.key === "Escape") onClose?.();
          if (e.key === "Enter") handleDelete();
        },
      }}
    >
      <div className="modal-header">
        <h2 id="confirm-title" className="modal-title">
          Delete score
        </h2>
        <p className="modal-subtitle">This action cannot be undone.</p>
      </div>

      <div className="modal-body">
        <p className="modal-message">Do you really want to delete this score?</p>
        {(title || artist) && (
          <div className="modal-score-info">
                  <div className="score-card-icon">
                      <MusicalNoteIcon />
                  </div>
            <div className="modal-score-text">
              {title && <div className="modal-score-title">{title}</div>}
              {artist && (
                <div className="modal-score-artist">{artist}</div>
              )}
            </div>
          </div>
        )}
      </div>

      <div className="modal-footer modal-buttons">
        <button
          className="cancel"
          onClick={onClose}
          disabled={submitting}
        >
          Cancel
        </button>
        <button
          className="delete"
          onClick={handleDelete}
          disabled={submitting}
        >
          {submitting ? "Deleting..." : "Delete"}
        </button>
      </div>
    </Modal>
  );
};

export default DeleteScoreModal;
